module.exports = __webpack_public_path__ + "media/a2.72aa10de.mp4";